export default __webpack_public_path__ + "static/media/weddingWebLogo.67c52a7f.png";